import { Box, Modal, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import OutlinedButton from "../buttons/OutlinedButton";
import Dangerbtn from "../buttons/Dangerbtn";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { userLogout } from "../../redux/actions/AuthAction";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import { useClerk } from "@clerk/clerk-react";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 5,
};

interface logoutmodel {
  logoutmodel: boolean;
  setLogoutModel: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalLogout: React.FC<logoutmodel> = ({
  logoutmodel,
  setLogoutModel,
}) => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { signOut } = useClerk(); // Clerk hook

  const Auth = useSelector((state: RootState) => state.Auth);
  const dispatch = useDispatch();
  const { userLogout: userlogout } = bindActionCreators(
    { userLogout },
    dispatch
  );

  const handleClose = () => {
    if (!loading) setLogoutModel(false);
  };

  const handleLogOut = async () => {
    try {
      setLoading(true);
      await signOut(); // Clerk sign out
      // Optional: userlogout(); for Redux cleanup
    } catch (error) {
      console.error("Logout failed", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      disableScrollLock={true}
      open={logoutmodel}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <center>
          <div className="logout-div">
            <LogoutIcon sx={{ fontSize: "35px" }} />
          </div>
          <div className="py-4">
            <span className="font-bold text-[20px] text-[#FA2020]">
              Log Out
            </span>
          </div>
          <span className="text-gray-500">
            Are you sure you want to log out of this account?
          </span>
          <div className="flex gap-3 justify-center pt-4">
            <OutlinedButton onClick={handleClose} label="Cancel" />
            <Dangerbtn
              onClick={handleLogOut}
              loading={loading}
              label={"Log Out"}
              disabled={loading}
            />
          </div>
        </center>
      </Box>
    </Modal>
  );
};

export default ModalLogout;
